module.exports = __webpack_public_path__ + "img/xyh.f0154070.jpg";